import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactForm } from '../contact-form/contact-form';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, ContactForm],
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class Footer {
  s3BaseUrl = environment.s3BaseUrl;
  
  getImageUrl(path: string): string {
    return `${this.s3BaseUrl}/${path}`;
  }
}
